import { render, staticRenderFns } from "./ClinicShowBankOrderItem.vue?vue&type=template&id=5338ef92"
import script from "./ClinicShowBankOrderItem.vue?vue&type=script&lang=js"
export * from "./ClinicShowBankOrderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports